import React from "react";
import { DANCE_ROLES, ROLE_LABELS } from "../lib/dance";
import FormLabel from "./FormLabel";
import FormFieldError from "./FormFieldError";
import { ChoiceToggleGroup } from "./createEvent/CreateEventFormUi";

/**
 * Shared Leader / Follower / Both control for RSVP, profile, and host flows.
 * One selected style everywhere (ink fill) — role color is for badges, not toggles.
 *
 * @param {"readable"|"sticker"} [variant="readable"] Kept for call-site compat; both use ChoiceToggleGroup.
 * @param {boolean} [annotated=false] When true, show ROLE_LABELS with masc/femme hints.
 */
export default function DanceRoleField({
  value,
  onChange,
  label = "I dance as",
  required = false,
  variant: _variant = "readable",
  annotated = false,
  testIdPrefix = "role",
  error,
  errorId,
  id,
  className = "",
  labelClassName = "block mb-2",
}) {
  const labelText = required ? `${label} *` : label;

  return (
    <fieldset id={id} className={`min-w-0 border-0 p-0 m-0 ${className}`}>
      <FormLabel as="legend" className={labelClassName}>
        {labelText}
      </FormLabel>
      <ChoiceToggleGroup
        options={DANCE_ROLES.map((role) => ({
          k: role,
          label: annotated ? ROLE_LABELS[role] : role,
        }))}
        value={value}
        onChange={onChange}
        testIdPrefix={testIdPrefix}
      />
      {error ? <FormFieldError id={errorId}>{error}</FormFieldError> : null}
    </fieldset>
  );
}
